import { Box, Divider, SimpleGrid, Stack } from '@chakra-ui/react';
import type { ShiptoDepositCrud } from '@diamond/shared/schema/shipto-deposit';
import { IconButton, Text } from '@diamond/shared/ui';
import type { OrderHistoryPoLookupRow } from '@diamond/sol-buyer/utils';
import { AccountBalanceWalletOutlined } from '@mui/icons-material';

import { BuyerProfileCard } from '../BuyerProfileCard';
import { NlbTransactionHistoryTable } from './NlbTransactionHistoryTable';
import { PaymentInfoSidebar } from './PaymentInfoSidebar';

export interface PaymentInfoNlbLayoutProps {
  paymentMethod: string;
  balance: ShiptoDepositCrud['getBalance']['response'] | undefined;
  showNlbBalance: boolean;
  histories:
    | ShiptoDepositCrud['getTransactionHistories']['response']
    | undefined;
  historiesLoading: boolean;
  historiesError: boolean;
  historyPage: number;
  onHistoryPageChange: (page: number) => void;
  onHistoryRetry: () => void;
  orders: OrderHistoryPoLookupRow[] | undefined;
  warehouseId: string;
}

function PaymentInfoNlbMobileCard({ children }: { children: React.ReactNode }) {
  return (
    <Box
      border="1px solid"
      borderColor="gray.33"
      borderRadius="lg"
      bg="white"
      p={4}
    >
      {children}
    </Box>
  );
}

function PaymentInfoNlbMobileHeader() {
  return (
    <>
      <Stack direction="row" spacing={4} align="center" pb={4}>
        <IconButton
          aria-label="Info Pembayaran"
          name="Info Pembayaran"
          icon={<AccountBalanceWalletOutlined />}
          variant="outline"
          borderWidth="1px"
          borderColor="blue"
          color="blue"
        />
        <Text fontWeight="semibold">Info Pembayaran</Text>
      </Stack>
      <Divider borderColor="gray.33" mb={4} />
    </>
  );
}

export function PaymentInfoNlbLayout({
  paymentMethod,
  balance,
  showNlbBalance,
  histories,
  historiesLoading,
  historiesError,
  historyPage,
  onHistoryPageChange,
  onHistoryRetry,
  orders,
  warehouseId,
}: PaymentInfoNlbLayoutProps) {
  const sidebar = (
    <PaymentInfoSidebar
      paymentMethod={paymentMethod}
      balance={balance}
      showNlbBalance={showNlbBalance}
    />
  );

  const historyTable = (
    <NlbTransactionHistoryTable
      data={histories}
      isLoading={historiesLoading}
      isError={historiesError}
      page={historyPage}
      onPageChange={onHistoryPageChange}
      orders={orders}
      warehouseId={warehouseId}
      onRetry={onHistoryRetry}
    />
  );

  return (
    <>
      <Stack spacing={4} display={{ base: 'flex', md: 'none' }}>
        <PaymentInfoNlbMobileCard>
          <PaymentInfoNlbMobileHeader />
          {sidebar}
        </PaymentInfoNlbMobileCard>
        <PaymentInfoNlbMobileCard>{historyTable}</PaymentInfoNlbMobileCard>
      </Stack>

      <Box display={{ base: 'none', md: 'block' }}>
        <BuyerProfileCard
          icon={<AccountBalanceWalletOutlined />}
          cardTitle="Info Pembayaran"
          contentOverflow="visible"
        >
          <SimpleGrid columns={2} spacing={10}>
            {sidebar}
            <Box minW={0}>{historyTable}</Box>
          </SimpleGrid>
        </BuyerProfileCard>
      </Box>
    </>
  );
}
